import { RQ, getRouteUrl, isWechat, isIOS } from 'utils';
import { share } from 'utils/wx';
import config from 'config';
import { addClickAnalytics } from 'utils/analytics';

export default {

};



// WEBPACK FOOTER //
// ./src/module/wechat/action.js